import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createStyles, Grid, makeStyles, Theme, useMediaQuery, useTheme } from '@material-ui/core';
import {Helmet} from "react-helmet";
import Header from '../common/ToolsHeader';
import MobileAppHeader from '../common/MobileAppHeader';
import React from 'react';
import MobileCover from '../common/MobileCover';
import { getIsMobileApp } from '../../utils/mobileApp';
import Settings from './settings';
import Tabs from './tabs';
import Authentication from '../common/Authentication';
import LoginRegisterContainer from '../common/LoginRegisterContainer';
import { userSubscribed, useUserId } from '../utils/authentication';
import { APIConstants } from '../utils/api/constants';
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer'
import Subscribe from '../common/Subscribe';

const useStyles = makeStyles((theme: Theme) =>createStyles({
    root: {
      minHeight: '100vh',
      backgroundColor: '#000A16',
      color: theme.palette.common.white,
      fontFamily: 'Roboto',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    contentWrapper: {
      paddingBottom: 40,
    }
  })
);

const queryClient = new QueryClient();


const Projections = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const userId = useUserId();
  const { authenticated, selectedSite, selectedSport } = useSelector((state: IRootState) => state.common);
  const isUserSubscribed = userSubscribed(authenticated, selectedSite, selectedSport);
  const isAuthInProgress = authenticated.status === APIConstants.STARTED || authenticated.status === APIConstants.UNSTARTED;

  return (
    <QueryClientProvider client={queryClient}>
      <Authentication app='DATAHUB'>
        <Helmet>
          <title>Data Hub</title>
          <meta name='description' content='Stokastic Projections for all sports and slates.' />
        </Helmet>
        <MobileCover>
          <Grid className={classes.root} style={isMobile ? { overscrollBehavior: 'none', touchAction: 'none' } : undefined}>
            {!getIsMobileApp() && <Grid item xs={12}><Header /></Grid>}
            <MobileAppHeader title="Data Hub" />
            {
              userId ? (
                <Grid container item xs={12} className={classes.contentWrapper}>
                  <Grid item xs={12}><Settings app={'DATAHUB'}/></Grid>
                  {
                    isUserSubscribed ? <Grid item xs={12}><Tabs app={'DATAHUB'} /></Grid> : isAuthInProgress ? null : <Subscribe toolName='Data Hub' />
                  }
                </Grid>
              ) : <LoginRegisterContainer toolName='Data Hub' />
            }
          </Grid>
        </MobileCover>
      </Authentication>
    </QueryClientProvider>
  )
}

export default Projections;
